import { Star, MessageSquareQuote } from "lucide-react";
import { useApi } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const Stars = ({ n }) => (
  <span className="inline-flex">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`h-3.5 w-3.5 ${i <= Math.round(n) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />)}</span>
);

export const ChatRatingReport = ({ from, to }) => {
  const { data } = useApi(`/chat-admin/ratings?date_from=${from}&date_to=${to}`);
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5 mt-6" data-testid="chat-rating-report">
      <div className="flex items-center gap-2 mb-3">
        <MessageSquareQuote className="h-5 w-5 text-amber-500" />
        <h2 className="font-bold text-slate-900">Rating Layanan Chat</h2>
      </div>
      {!data?.staff?.length && <p className="text-sm text-slate-500" data-testid="chat-rating-empty">Belum ada penilaian dari anggota pada periode ini.</p>}
      {data?.staff?.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-slate-500 text-xs"><th className="p-2">Petugas</th><th className="p-2">Rata-rata</th><th className="p-2 text-right">Jumlah</th><th className="p-2 text-right">Bintang 5</th></tr></thead>
            <tbody>
              {data.staff.map((s) => (
                <tr key={s.staff_id} className="border-t border-slate-100" data-testid={`chat-rating-row-${s.staff_id}`}>
                  <td className="p-2 font-semibold">{s.name}</td>
                  <td className="p-2"><span className="inline-flex items-center gap-1.5"><Stars n={s.avg} /><b>{s.avg.toFixed(1)}</b></span></td>
                  <td className="p-2 text-right">{s.count}</td>
                  <td className="p-2 text-right">{s.five}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {data?.recent?.length > 0 && (
        <div className="mt-4 space-y-2">
          <div className="text-xs font-bold text-slate-500">Penilaian terbaru</div>
          {data.recent.map((r) => (
            <div key={r.rating_id} className="border border-slate-100 rounded-xl p-3 text-sm">
              <div className="flex justify-between gap-2"><span className="font-semibold">{r.member_name} → {r.staff_name}</span><Stars n={r.stars} /></div>
              {r.comment && <p className="text-slate-600 text-xs mt-1">"{r.comment}"</p>}
              <div className="text-[11px] text-slate-400 mt-1">{fmtDateTime(r.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
